<template>
  <div class="w-full flex flex-wrap delivery-info">
    <div class="left lg:w-2/6 w-full">
      <div class="deliveryItem iPickup w-full py-8 rounded-md">
        <div class="text-titlevsm md:text-titlevsm tb:text-titlemd title font-medium">
          {{ lang.text1 }}
        </div>
      </div>
    </div>
    <div class="right lg:w-4/6 w-full flex flex-wrap">
      <div class="deliveryItem iPickup md:w-1/2 w-full p-8 rounded-md" v-if="lang.text2 && country != 'RO'"> 
        <div class="smallTitle mb-3">{{ lang.text2 }}</div>
        <div class="text mb-4" v-html="lang.text21"></div>
      </div>
      <div class="deliveryItem iPickup md:w-1/2 w-full p-8 rounded-md" v-else> 
        <div class="smallTitle mb-3">{{ lang.text5 }}</div>
        <div class="text mb-4" v-html="lang.text51"></div>
      </div>
      <div class="deliveryItem iPickup md:w-1/2 w-full p-8 rounded-md" v-if="lang.text3 && country != 'RO'">
        <div class="smallTitle mb-3">{{ lang.text3 }}</div>
        <div class="text mb-4" v-html="lang.text31"></div>
      </div>
      <div class="deliveryItem iPickup md:w-1/2 w-full p-8 rounded-md" v-else> 
        <div class="smallTitle mb-3">{{ lang.text2 }}</div>
        <div class="text mb-4" v-html="lang.text21"></div>
      </div>
      <div class="deliveryItem iPickup md:w-1/2 w-full p-8 rounded-md" v-if="lang.text4 && country != 'RO'">
        <div class="smallTitle mb-3">{{ lang.text4 }}</div>
        <div class="text mb-4" v-html="lang.text41"></div>
      </div>
      <div class="deliveryItem iPickup md:w-1/2 w-full p-8 rounded-md" v-if="lang.text5 && country != 'RO'">
        <div class="smallTitle mb-3">{{ lang.text5 }}</div>
        <div class="text mb-4" v-html="lang.text51"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IPickup",
  props: {
    lang: [],
    country: String,
  },
};
</script>

<style scoped>
.delivery-info {
  margin-top: 55px;
}
.title {
  color: #333f48;
  font-weight: 500;
}
.smallTitle {
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
}
.text {
  font-size: 16px;
  line-height: 18.96px;
}
</style>